import { BehaviorSubject, Observable } from 'rxjs';

export abstract class IGlobalStateService {
  protected readonly loadingSubject$ = new BehaviorSubject<boolean>(false);

  abstract get loading$(): Observable<boolean>;

  abstract setLoading(isLoading: boolean): void;
}
